// Assessment Status API Configuration
export const ASSESSMENT_STATUS_CONFIG = {
  BASE_URL: `${import.meta.env.VITE_API_BASE_URL}/food_scanner`,
  TENANT_ID: "ab9bb443-b2ef-4b55-b0ed-0b4a41bb2dc8",
  TIMEOUT: 30000, // 30 seconds
  RETRY_COUNT: 2,
  RETRY_DELAY_BASE: 1000, // 1 second base delay

  ENDPOINTS: {
    CHECK_COMPLETION: "/new-assessment/check_assessment_completion/",
  },

  CACHE: {
    TTL: 5 * 60 * 1000, // 5 minutes
    MAX_SIZE: 10, // Maximum cache entries
  },

  RESPONSE_FORMATS: {
    // Possible response field names for completion status
    COMPLETION_FIELDS: [
      "isComplete",
      "completed",
      "has_assessment",
      "assessment_completed",
      "is_completed",
    ],
    STATUS_VALUES: {
      COMPLETE: ["complete", "completed", "finished", "done"],
      INCOMPLETE: ["incomplete", "pending", "in_progress", "not_started"],
    },
  },
} as const;

// Helper function to get status endpoints
export const getStatusEndpoints = () => ({
  checkCompletion: `${ASSESSMENT_STATUS_CONFIG.BASE_URL}${ASSESSMENT_STATUS_CONFIG.ENDPOINTS.CHECK_COMPLETION}`,
});

// Type-safe config getters
export const getStatusConfig = () => ASSESSMENT_STATUS_CONFIG;
